import { render, staticRenderFns } from "./StandardReport.vue?vue&type=template&id=2a2e35e1&"
import script from "./StandardReport.vue?vue&type=script&lang=js&"
export * from "./StandardReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports